import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { clearStorage } from "../../Helpers/clearStorage";
import { enqueueSnackbar } from "notistack";
import { useWorkspaceColors } from "../../Contexts/WorkspaceColorContext";
import Loading from "../Common/Loading";
import color from "../../Constants/colors";

const Logout = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { colors: workspace } = useWorkspaceColors();

  useEffect(() => {
    const logout = async () => {
      try {
        await clearStorage([
          "cw_conversation",
          "cw_clearence",
          "cih_token",
          "persist:annex:v1",
        ]);

        queryClient.removeQueries();

        // FORCE FULL RELOAD (NAVIGATING IN SPA DOES NOT CLEAR CONTEXT)
        window.location.href = "/login";
      } catch {
        enqueueSnackbar("Error during logout", { variant: "error" });
        navigate("/home", { replace: true });
      }
    };

    logout();
  }, [navigate, queryClient]);

  return (
    <Loading
      backgroundColor={color.gray100}
      color1={workspace.accent}
      color2={workspace.primary_dark}
    />
  );
};

export default Logout;
